var regexMap = {
  url: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
  validURL: /^(https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/
};
export function isURL(url) {
  return regexMap.url.test(url);
}
export function isValidURL(url) {
  return regexMap.validURL.test(url);
}
//# sourceMappingURL=validate.js.map